// extracted by css-extract-rspack-plugin
export default {"root":"rUWwfu","logo":"DjGATF","header":"OmS6Qe","completeMessage":"t7rchs","input":"fCRUf2","captcha":"yny44o","button":"hQEEkD","submitWrapper":"xgH30k","signInRow":"uLO4E8"};